// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__3ubvy","title":"Navbar_title__3-bPa"};